import  {eXcell,__extends} from './eXcell';

var eXcell_link = (function (_super) {
    __extends(eXcell_link, _super);
    function eXcell_link(a) {
        _super.call(this);
        this.cell = a;
        this.grid = this.cell.parentNode.grid;
    }
    eXcell_link.prototype.isDisabled = function () {
        return true;
    };
    eXcell_link.prototype.edit = function () { };
    eXcell_link.prototype.getValue = function () {
        if (this.cell.firstChild.getAttribute) {
            var c = this.cell.firstChild.getAttribute("target");
            return (this.cell.firstChild.innerHTML +
                "^" +
                this.cell.firstChild.getAttribute("href") +
                (c ? "^" + c : ""));
        }
        else {
            return "";
        }
    };
    eXcell_link.prototype.setValue = function (e) {
        if (typeof e != "number" && (!e || e.toString()._dhx_trim() == "")) {
            this.setCValue("&nbsp;", c);
            return (this.cell._clearCell = true);
        }
        var c = e.split("^");
        if (c.length == 1) {
            c[1] = "";
        }
        else {
            if (c.length > 1) {
                c[1] = "href='" + c[1] + "'";
                if (c.length == 3) {
                    c[1] += " target='" + c[2] + "'";
                }
                else {
                    c[1] += " target='_blank'";
                }
            }
        }
        this.setCValue("<a " +
            c[1] +
            " onclick='(dhx4.isIE?event:arguments[0]).cancelBubble = true;'>" +
            c[0] +
            "</a>", c);
    };
    eXcell_link.prototype.getTitle = function () {
        var a = this.cell.firstChild;
        return a && a.tagName ? a.getAttribute("href") : "";
    };
    eXcell_link.prototype.getContent = function () {
        var a = this.cell.firstChild;
        return a && a.tagName ? a.innerHTML : "";
    };
    return eXcell_link;
})(eXcell);
window.eXcell_link = eXcell_link;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_link.js